import * as React from 'react';
export const IcNamaste = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M10.1 3a1 1 0 00-.71.18 1 1 0 00-.39.63l-1.92 9.71-.76.75-.46-.77A1.059 1.059 0 005 13H4a1 1 0 00-.85.48A1 1 0 003 14a.93.93 0 00.11.49l3 6c.07.142.173.265.3.36.129.09.275.152.43.18H7a1 1 0 00.38-.07c.123-.052.235-.127.33-.22l1-1a.94.94 0 00.29-.61 1 1 0 00-.13-.64l-.35-.59 1.9-1.9a2 2 0 00.58-1.4V4a1 1 0 00-.9-1zm10.75 10.5a1 1 0 00-.37-.34 1 1 0 00-.48-.12h-1a1 1 0 00-.49.13.998.998 0 00-.37.35l-.46.77-.76-.75L15 3.9a.941.941 0 00-.36-.67A1 1 0 0013.9 3a1 1 0 00-.67.37.999.999 0 00-.23.73v10.53a2 2 0 00.58 1.4l1.9 1.89-.35.58a1 1 0 00-.13.64c.031.218.129.42.28.58l1 1c.097.091.208.166.33.22A1 1 0 0017 21h.16a1.09 1.09 0 00.43-.18c.127-.095.23-.218.3-.36l3-6c.073-.142.11-.3.11-.46a1.08 1.08 0 00-.15-.49v-.01z'
      fill='currentColor'
    />
  </svg>
);
